@if (hasNavigteToDataExplorerAction$ | async) {
  <div class="flex justify-end">
    <button
      class="px-[7px]"
      nz-tooltip
      nzTooltipTitle="View in Data Explorer"
      nz-button
      nzSize="default"
      nzType="text"
      (click)="navigateToDataExplorer(ruleBk)"
    >
      <twaice-fe-svg-icon size="16px" source="tabler" name="external-link" />
    </button>
  </div>
}
